import React from "react";

interface Props {
  /** e.g. "transactions", "categorized expenses" */
  metricLabel?: string;
}

// Shown in place of a chart when the selected range has zero rows at all —
// distinct from NotEnoughDataEmptyState, which is for a range that has some
// data but not enough to plot a meaningful trend.
export const NoDataEmptyState: React.FC<Props> = ({ metricLabel = "data" }) => (
  <div className="flex flex-col items-center justify-center py-10 sm:py-16 px-4 sm:px-6 text-center">
    <div className="mb-4 sm:mb-5 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-slate-100 flex items-center justify-center">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18" />
        <path d="M7 16v-3M12 16V9M17 16v-6" />
      </svg>
    </div>
    <p className="text-sm font-semibold text-slate-800">No data for this period</p>
    <p className="text-xs text-slate-500 mt-1 max-w-sm">
      There's no {metricLabel} in the selected date range. Try a wider range or a different period.
    </p>
  </div>
);

export default NoDataEmptyState;
